import { createAction } from '@reduxjs/toolkit';
import { RequestError, Callback, CompensationSentence, CompensationSentenceParams } from 'types';

export const updateCompensationSentence = createAction(
  'compensation-sentence/update',
  (compensationSentence: CompensationSentenceParams, callback?: Callback<unknown, void>) => ({
    payload: undefined,
    meta: { compensationSentence, callback },
  })
);

export const updatedCompensationSentence = createAction(
  'compensation-sentence/updated',
  (data?: CompensationSentence, error?: RequestError) => ({
    payload: error || data,
    error: Boolean(error),
  })
);

export default {
  updateCompensationSentence,
  updatedCompensationSentence,
};
